import request from '@/utils/request'

// 查询空间停留记录列表
export function listSpaceStayRecord(query) {
  return request({
    url: '/system/space-stay-record/list',
    method: 'get',
    params: query,
  })
}

// 查询空间停留记录分页
export function pageSpaceStayRecord(query) {
  return request({
    url: '/system/space-stay-record/page',
    method: 'get',
    params: query,
  })
}

// 查询空间停留记录详细
export function getSpaceStayRecord(data) {
  return request({
    url: '/system/space-stay-record/detail',
    method: 'get',
    params: data,
  })
}

// 新增空间停留记录
export function addSpaceStayRecord(data) {
  return request({
    url: '/system/space-stay-record/add',
    method: 'post',
    data: data,
  })
}

// 修改空间停留记录
export function updateSpaceStayRecord(data) {
  return request({
    url: '/system/space-stay-record/edit',
    method: 'post',
    data: data,
  })
}

// 删除空间停留记录
export function delSpaceStayRecord(data) {
  return request({
    url: '/system/space-stay-record/delete',
    method: 'post',
    data: data,
  })
}
